module.exports = __webpack_public_path__ + "media/images/icons/droplet-3f3798e4a7f989f41509f7877739e22a.svg";